<template>
    <main>
      <search-toolbar resultType='clubs' :from="from" :to="to" :sortFields="sortFields" :totalCount="totalCount"
        @search="getFacilities($event)" @clearsearch="clearSearch($event)" @changeSort="changeSort($event)" />
      <div class="md-layout" id='facilitylist'>
        <div class="md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100" v-for="(facility, index) in facilities"
          :key="index">
          <md-list class="md-double-line">
            <md-list-item @click="selectfacility(facility)">
              <img v-if="facility.logoUrl" class="facility-logo" :src=facility.logoUrl :alt=facility.name  @error="onError">
              <div class="md-list-item-text">
                <span v-text="setName(facility)"></span>
                <span v-text="setCity(facility)"></span>
              </div>
            </md-list-item>
          </md-list>
        </div>
      </div>
    </main>
</template>

<script>
import SearchToolbar from '@/components/elements/search-toolbar'
import NavigationLayout from '@/components/layouts/navigation'
import RepositoryService from '@/services/repositoryService'
import router from '@/router'
import Utils from '@/utils/utils'
import {infiniteScroll} from '@/utils/infinite-scroll'
import NotificationService from '@/services/notificationService'

export default {
  name: 'search-chain-facilities',
  data: () => ({
    selectedChain: RepositoryService.session.selectedFacility,
    searchInput: '',
    facilities: [],
    totalCount: null,
    sortOrder: 'asc',
    selectedSortField: 'facilityName',
    sortFields: ['facilityName'],
    from: 0,
    to: 60
  }),
  mixins: [infiniteScroll],
  props: ['parentref'],
  components: {
    NavigationLayout,
    SearchToolbar
  },
  methods: {
    setName (facility) {
      if (facility.chainFacilityId && facility.chainFacilityId !== '') {
        return facility.name + ' (' + facility.chainName + ')'
      } else {
        return facility.name
      }
    },
    setCity (facility) {
      if (facility.city && facility.city !== '' && facility.address && facility.address !== '') {
        return facility.city + ', ' + facility.address
      } else {
        return ''
      }
    },
    async selectfacility (selectedfacility) {
      await NotificationService.manageNotification(this.parentref, await RepositoryService.facilityDetails(selectedfacility.id),
        (data) => {
          RepositoryService.session.setselectedFacility({...selectedfacility, ...data})
          router.push({
            name: 'facilitymenu'
          })
        })
    },
    changeSort (sort) {
      this.sortOrder = sort
      this.facilities = this.facilities.sort(this.sortOrder === 'asc' ? Utils.orderArrayObjectByFieldAlphabeticalAscInvariant(
        'name') : Utils.orderArrayObjectByFieldAlphabeticalDescInvariant('name'))
    },
    async getFacilities (searchBody) {
      this.searchInput = searchBody.textFilter
      await NotificationService.manageNotification(this.parentref, await RepositoryService.searchFacilitiesByChain(searchBody),
        (data) => {
          var results = data.items.sort(searchBody.SortOrder === 'asc' ? Utils.orderArrayObjectByFieldAlphabeticalAscInvariant(
            'name') : Utils.orderArrayObjectByFieldAlphabeticalDescInvariant('name'))
          this.facilities = results
          this.totalCount = data.totalCount
        })
    },
    clearSearch () {
      this.from = 0
      this.to = 60
      this.searchInput = ''
      this.getFacilities({
        'chainFacilityId': this.selectedChain.id,
        'from': this.from,
        'to': this.to,
        'SortOrder': this.sortOrder,
        'textFilter': this.searchInput,
        'SortField': this.selectedSortField
      })
    },
    async infiniteHandler () {
      if (!this.totalCount || this.to <= this.totalCount) {
        this.from = this.to + 1
        this.to += 60
        var searchBody = {
          'chainFacilityId': this.selectedChain.id,
          'from': this.from,
          'to': this.to,
          'SortOrder': this.sortOrder,
          'textFilter': this.searchInput,
          'SortField': this.selectedSortField
        }
        await NotificationService.manageNotification(this.parentref, await RepositoryService.searchFacilitiesByChain(searchBody),
          (data) => {
            var results = data.items.sort(searchBody.SortOrder === 'asc' ? Utils.orderArrayObjectByFieldAlphabeticalAscInvariant(
              'name') : Utils.orderArrayObjectByFieldAlphabeticalDescInvariant('name'))
            for (var i = 0; i < results.length; i++) {
              this.facilities.push(results[i])
            }
            this.totalCount = data.totalCount
          })
      }
    },
    onError (e) {
      let defaultURL = 'https://cdnmedia.mywellness.com/facility_resources/images/defaultlogo.png'
      if (e.target.src !== defaultURL) {
        e.target.src = defaultURL
      }
    }
  },
  created: function () {
    if (this.facilities !== []) {
      if (!RepositoryService.session.billingCompanies) {
        router.push({
          name: 'login'
        })
      }
    }
  },
  mounted: async function () {
    // Initially load some items.
    this.getFacilities({
      'chainFacilityId': this.selectedChain.id,
      'from': this.from,
      'to': this.to,
      'SortOrder': this.sortOrder,
      'textFilter': this.searchInput,
      'SortField': this.selectedSortField
    })
  }
}

</script>

<style lang="scss" scoped>
  .md-list {
    width: 320px;
    max-width: 100%;
    display: inline-block;
    vertical-align: top;
    border: 1px solid rgba(#000, .12);
  }

  .facility-logo {
    max-width: 80px;
    max-height: 30px;
    vertical-align: middle;
    margin-right: 10px;
  }

</style>
